import type { RouteObject } from 'react-router'

// market
import { Order } from '../pages/market/Order'
// myPage
import { MyPage } from '../pages/myPage/MyPage'
import { Asset } from '../pages/myPage/Asset'
import { ProductDetail as MyProductDetail } from '../pages/myPage/ProductDetail'
import { SaleInfo } from '../pages/myPage/SaleInfo'
import { ProductCalculate } from '../pages/myPage/ProductCalculate'
import { SettlementDetail } from '../pages/myPage/SettlementDetail'
import { Account } from '../pages/myPage/Account'
import { AccountWithdrawal } from '../pages/myPage/AccountWithdrawal'
import { DepositAccount as MyDepositAccount } from '../pages/myPage/DepositAccount'
import { CreateWithdrawal } from '../pages/myPage/CreateWithdrawal'
import { SelectWithdrawalBank } from '../pages/myPage/SelectWithdrawalBank'
import { SuccessWithdrawal } from '../pages/myPage/SuccessWithdrawal'
import { DepositTerms } from '../pages/myPage/DepositTerms'
import { SuccessDeposit } from '../pages/myPage/SuccessDeposit'
// setting
import { PersonalInfo } from '../pages/settings/personalInfo'
import { PhoneVerification } from '../pages/settings/personalInfo'
import { Address } from '../pages/settings/personalInfo'
import { Qna } from '../pages/settings/qna'
import { QnaDetail } from '../pages/settings/qna'
import { QnaRegister } from '../pages/settings/qna'
import { WithdrawalAccount } from '../pages/settings/personalInfo'
import { DepositAccount as SettingDepositAccount } from '../pages/settings/personalInfo'
import { Notification } from '../pages/settings/notification/Notification'
import { WithdrawalUser } from '../pages/auth/WithdrawalUser'

export const PROTECTED_ROUTES: RouteObject[] = [
  // market
  { path: '/market/product/:id/order', element: <Order /> },

  // mypage
  { path: '/myPage', element: <MyPage /> },
  { path: '/myPage/asset', element: <Asset /> },
  { path: '/myPage/asset/:userProductId', element: <MyProductDetail /> },
  { path: '/myPage/asset/:userProductId/saleInfo', element: <SaleInfo /> },
  { path: '/myPage/asset/:userProductId/calculate', element: <ProductCalculate /> },
  { path: '/myPage/asset/:userProductId/settlement', element: <SettlementDetail /> },
  { path: '/myPage/account', element: <Account /> },
  { path: '/myPage/account/withdrawal', element: <AccountWithdrawal /> },
  { path: '/myPage/account/deposit', element: <MyDepositAccount /> },

  // 계좌 관련
  { path: '/account/withdrawal/create', element: <CreateWithdrawal /> },
  { path: '/account/withdrawal/banks', element: <SelectWithdrawalBank /> },
  { path: '/account/withdrawal/success', element: <SuccessWithdrawal /> },
  { path: '/account/deposit/terms', element: <DepositTerms /> },
  { path: '/account/deposit/success', element: <SuccessDeposit /> },

  // 사용자 설정
  { path: '/personalInfo', element: <PersonalInfo /> },
  { path: '/personalInfo/phone', element: <PhoneVerification /> },
  { path: '/address', element: <Address /> },

  // QnA
  { path: '/qna', element: <Qna /> },
  { path: '/qna/:qnaId', element: <QnaDetail /> },
  { path: '/qna/register', element: <QnaRegister /> },

  // 기타 설정
  { path: '/withdrawalAccount', element: <WithdrawalAccount /> },
  { path: '/depositAccount', element: <SettingDepositAccount /> },
  { path: '/push', element: <Notification /> },
  { path: '/withdrawalUser', element: <WithdrawalUser /> },
]
